import { applyMiddleware, compose, createStore } from 'redux';
import reducers from '../reducers/index';
import createHistory from 'history/createHashHistory';
import createSagaMiddleware from 'redux-saga';
import rootSaga from '../sagas/index';
import createSocketIoMiddleware from 'redux-socket.io';
import io from 'socket.io-client';
import { routerMiddleware } from 'react-router-redux';
import authTokenMiddleware from './middleware';
import { CONNECTION_ERROR, CONNECTION_SUCCESS } from 'constants/ActionTypes';
import { store } from 'MainApp';

const history = createHistory();
const routeMiddleware = routerMiddleware(history);
const sagaMiddleware = createSagaMiddleware();

const socket =
    process.env.NODE_ENV === 'production'
        ? io('https://www.meldooplus.de', {
              path: '/api/socket.io'
          })
        : io('http://localhost:3010');

socket.on('connect_error', error => {
    store.dispatch({ type: CONNECTION_ERROR });
});

socket.on('connect', () => {
    store.dispatch({ type: CONNECTION_SUCCESS });
});

const socketIoMiddleware = createSocketIoMiddleware(socket, 'server/', {
    execute: authTokenMiddleware
});
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function configureStore(initialState) {
    const middlewares = socket.hasListeners('action') ? [sagaMiddleware, routeMiddleware] : [sagaMiddleware, routeMiddleware, socketIoMiddleware];

    const store = createStore(reducers, initialState, composeEnhancers(applyMiddleware(...middlewares)));

    sagaMiddleware.run(rootSaga);

    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept('../reducers/index', () => {
            const nextRootReducer = require('../reducers/index');
            store.replaceReducer(nextRootReducer);
        });
    }

    return store;
}
export { history };



// WEBPACK FOOTER //
// ./store/index.js